import { Row, Col as AntdCol } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Row)<{ $xs?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;

  & > *:not(:first-child) {
    margin-top: 12px;
  }
  & > *:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const Col = styled(AntdCol)`
  max-width: 100%;
`;
